import { Country } from '../../../shared/typings';

export enum CURRENT_CAPTURE_ZOHO_LEADS_SCREEN {
  OTP = 'OTP',
  OTP_VERIFIED = 'OTP_VERIFIED',
  DETAILS = 'DETAILS',
  SUCCESS = 'SUCCESS',
}

export enum ZOHO_LEADS_FORM_KEYS {
  COMPANY_NAME = 'companyName',
  COUNTRY_CODE = 'countryCode',
  PHONE_NUMBER = 'phoneNumber',
  WEBSITE_URL = 'websiteUrl',
  BUSINESS_EMAIL = 'businessEmail',
}

export enum ZOHO_LEADS_FORM_LABELS {
  COMPANY_NAME = 'Company Name',
  PHONE_NUMBER = 'Phone Number',
  WEBSITE_URL = 'Website URL',
  BUSINESS_EMAIL = 'Business Email',
  COUNTRY_CODE = '',
}

export interface ZohoLeadsFormDetails {
  [ZOHO_LEADS_FORM_KEYS.COMPANY_NAME]: { value: string; isErrored: boolean };
  [ZOHO_LEADS_FORM_KEYS.COUNTRY_CODE]: { value: Country };
  [ZOHO_LEADS_FORM_KEYS.PHONE_NUMBER]: { value: string; isErrored: boolean };
  [ZOHO_LEADS_FORM_KEYS.WEBSITE_URL]: { value: string; isErrored: boolean };
  [ZOHO_LEADS_FORM_KEYS.BUSINESS_EMAIL]: { value: string; isErrored: boolean };
}

export interface SaveCustomerDetailsPayload {
  companyName: string;
  customerNumber: string;
  emailId: string;
  website: string;
}
